import { FlightService } from "../../services/flights/flight.service";
import { APIs } from "../api/APIs";
import SafeairManager from "../api/SafeairManager";

export class MedicalEmergencyHelper {
  getMedicalEmergency = async (medicalEmergencyId) => {
    const apiConfig = {
      api: APIs.MedicalEmergency.GetMedicalEmergency,
      parameters: {
        "medical-emergency-id": medicalEmergencyId,
      },
    };
    const res = await SafeairManager.invoke(apiConfig);
    return res.data;
  };

  async findCrew(medicalEmergencyId) {
    const medicalEmergency = await this.getMedicalEmergency(medicalEmergencyId);
    console.log("sssssss- crew--1", medicalEmergency);
    const crewUsername = medicalEmergency?.assignedCrew || medicalEmergency?.createdBy;

    console.log("sssssss- crew-0", crewUsername);
    let crewCognitoUserId = "";
    if (crewUsername) {
      const crew = (
        await SafeairManager.invoke({
          api: APIs.Crew.GetCrew,
          parameters: {
            "crew-id": crewUsername,
          },
        })
      ).data;
      console.log("sssssss- crew", crew);
      crewCognitoUserId = crew?.cognitoUserId;
      return crewCognitoUserId;
    }

    return null;
  }

  static async resetPassword(newPass) {
      const reset = (
        await SafeairManager.invoke({
          api: APIs.Crew.ResetPassword,
          parameters: null,
          body: {
            "newPassword": newPass,
          },
        })
      )
    return reset;
  }

  static async updateProfile(name,email,familyName,gender,username,phoneNumber) {
    const updateprofile = (
      await SafeairManager.invoke({
        api: APIs.User.UpdateEmsProfile,
        parameters: null,
        body: {
          "username": username,
          "phoneNumber": phoneNumber,
          "familyName": familyName,
          "email": email,
          "gender": gender,
          "name": name
        },
      })
    )

 

   console.log(updateprofile.data);
  return updateprofile.data;
}

  async findEms(medicalEmergencyId) {
    const medicalEmergency = await this.getMedicalEmergency(medicalEmergencyId);

    const emsUsername = medicalEmergency.assignedEms;
    let emsCognitoUserId = "";
    if (emsUsername) {
      const ems = (
        await SafeairManager.invoke({
          api: APIs.EMS.GetEms,
          parameters: {
            "ems-id": emsUsername,
          },
        })
      ).data;
      emsCognitoUserId = ems?.cognitoUserId;
      return emsCognitoUserId;
    }

    return null;
  }

  async findEmsName(medicalEmergencyId) {
    const medicalEmergency = await this.getMedicalEmergency(medicalEmergencyId);

    const emsUsername = medicalEmergency.assignedEms;
    if (emsUsername) {
      return emsUsername;
    }

    return null;
  }

  async findCrewName(medicalEmergencyId) {
    const medicalEmergency = await this.getMedicalEmergency(medicalEmergencyId);

    const crewUsername = medicalEmergency?.assignedCrew || medicalEmergency?.createdBy;
    if (crewUsername) {
      return crewUsername;
    }

    return null;
  }

  async findCaptain(flightId) {
    const flight = await FlightService.getFlight(flightId);
    const captainUsername = flight.captain;
    let cognitoUserId = "";
    if (captainUsername) {
      const captain = (
        await SafeairManager.invoke({
          api: APIs.Crew.GetCrew,
          parameters: {
            "crew-id": captainUsername,
          },
        })
      ).data;
      cognitoUserId = captain?.cognitoUserId;
      return cognitoUserId;
    }
    return null;
  }
}
